import get from "lodash/get"
import isEmpty from "lodash/isEmpty"
import { connect } from "react-redux"
import { AuthoringUtils } from "@adobe/aem-spa-page-model-manager"
import Footer from "./Footer"

let mapStateToProps = (state) => ({
  siteLanguage: state.siteLanguage,
})

if (!AuthoringUtils.isInEditor()) {
  mapStateToProps = (state, props) => {
    const aemDataObject = !isEmpty(props.dataPageData)
      ? props.dataPageData
      : state.aemData

    return {
      copyrightMessaging: get(aemDataObject, `footer.copyrightMessaging`, ``),
      logoIcon: get(aemDataObject, `footer.logoIcon`, ``),
      footerText: get(aemDataObject, `footer.footerText`, ``),
      legalLinks: get(aemDataObject, `footer.legalLinks`, []),
      logolink: get(aemDataObject, `standardnavigation.logoLink`, ``),
      columns: get(aemDataObject, `footer.columns`, []),
      siteLanguage: state.siteLanguage,
      brightEdge: state.onlineProducts,
      socialMediaLinks: get(aemDataObject, `footer.socialMediaLinks`, []),
      footernote: get(aemDataObject, `footer.footernote`, ``),
      alignment: get(aemDataObject, `footer.alignment`, ``),
      userManageAccount: state.userManageAccount,
      isSingleAccount:
        get(state.userManageAccount, `linkedAccounts.length`, 0) === 1,
    }
  }
}

export default connect(mapStateToProps)(Footer)
